export default Object.freeze({
	FORM_CLOSE: 'szn.discussion.from.form.close',
	FORM_POST: 'szn.discussion.from.form.post'
});
